import React from 'react';

type LargeTextboxProps = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  style?: React.CSSProperties;
};

const LargeTextbox = ({ value, onChange, placeholder, style }: LargeTextboxProps) => (
  <textarea
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    rows={4}
    style={{
      width: '100%',
      padding: '10px',
      fontSize: '1rem',
      borderRadius: '6px',
      border: '1px solid #ccc',
      resize: 'vertical',
      ...style,
    }}
  />
);

export default LargeTextbox;
